import contactDisplayNames from "../displayNames";
import {
  FormSection,
  PhoneInput,
  TextInput,
  DropDownLookUpInput,
  OptionSetInput
} from "../../../types";
import { vdl_fonctionChoices, vdl_salutationsChoices } from "./optionSetChoices";
import { contactOptionSetsChoices } from "../optionSetChoices";

export type EditProfileFields = {
  vdl_salutation: OptionSetInput;
  firstname: TextInput;
  lastname: TextInput;
  vdl_fonction: OptionSetInput;
  telephone1: PhoneInput;
  telephone2: PhoneInput;
};

const sectionInfos: FormSection<EditProfileFields> = {
  fields: [
    "firstname",
    "lastname",
    "vdl_fonction",
    "telephone1",
    "vdl_salutation",
    "telephone2",
  ],
  title: "Informations personnelles",
};

const editProfileSections: FormSection<EditProfileFields>[] = [
  sectionInfos
];

const editProfileFields: EditProfileFields = {
  vdl_salutation: {
    type: "options",
    error: "",
    value: null,
    choices: contactOptionSetsChoices.vdl_salutation,
    required: false,
    fillLine: true,
    label: contactDisplayNames.vdl_salutation,
  },
  firstname: {
    type: "text",
    value: "",
    error: "",
    required: true,
    label: contactDisplayNames.firstname,
  },
  lastname: {
    type: "text",
    value: "",
    error: "",
    required: true,
    label: contactDisplayNames.lastname,
  },
  vdl_fonction: {
    type: "options",
    value: null,
    error: "",
    choices: contactOptionSetsChoices.vdl_fonction,
    required: true,
    fillLine: true,
    label: contactDisplayNames.vdl_fonction,
  },
  telephone1: {
    type: "phone",
    value: "",
    error: "",
    required: true,
    label: contactDisplayNames.telephone1,
  },
  telephone2: {
    type: "phone",
    value: "",
    error: "",
    label: contactDisplayNames.telephone2,
  },
};

const editProfileForm = {
  fields: editProfileFields,
  sections: editProfileSections,
};

export { editProfileForm, editProfileFields, editProfileSections};
